module.exports = __webpack_public_path__ + "static/media/aws.8c9d4258.png";